import { Component, Input } from '@angular/core';
import { NonBvdComparableDetails } from './non-bvd-comparable-details.model';
import { DatabaseType } from '../../../../_study_constants';
import * as Constants from '@shared/_constants';

@Component({
  selector: 'app-non-bvd-display',
  templateUrl: './non-bvd-display.component.html',
  styleUrls: ['./non-bvd-display.component.css'],
})
export class NonBvdDisplayComponent {
  @Input() comparable: NonBvdComparableDetails;

  get isOneSource() {
    return this.comparable.databaseId === DatabaseType.OneSource;
  }

  get getOneSourceUrl() {
    return Constants.NonBvdComparableLinks.ONESOURCE_URL.replace(
      Constants.UrlQueryParamsPlaceholder.VENDOR_XREF,
      this.comparable.companyId.toString()
    );
  }

  get getSecUrl() {
    return this.comparable.comparableCIK
      ? Constants.NonBvdComparableLinks.SEC_URL.replace(Constants.UrlQueryParamsPlaceholder.KEY_ID, this.comparable.comparableCIK)
      : Constants.NonBvdComparableLinks.SEC_DEFAULT_URL;
  }
}
